import React from "react";

// reactstrap components
import { Button, Container, Row, Col, UncontrolledTooltip } from "reactstrap";
import MapContainer from "./MapContainer.js";
import irctc from "assets/img/irctc.png"

// core components

function Location() {
  return (
    <>
      <div
        className="section section-download"
        data-background-color="black"
        id="location-section"
      >
        <Container>
          <Row className="justify-content-md-center">
            <Col className="text-center" lg="8" md="12">
              <h3 className="title">About Us</h3>
              <h5 className="description">
              Fast food restaurant in Gudur, Nellore district
              </h5>
            </Col>
          </Row>
          <Row className="justify-content-md-center">
            <Col className="text-center" lg="8" md="12">
              <h3 className="title">Partners</h3>
              <h5 className="description">
              Official partner of IRCTC catering
              </h5>
              <img src={irctc} className="partnerImages"></img>
            </Col>
          </Row>          
          <Row className="justify-content-md-center sharing-area text-center">
            <Col className="text-center" lg="8" md="12">
              <h3>Thank you for supporting us!</h3>
            </Col>
            <Col className="text-center" lg="8" md="12">
             
              <Button
                className="btn-neutral btn-icon btn-round"
                color="facebook"
                href="https://www.facebook.com/chalorestro/"
                id="tooltip735272548"
                size="lg"
                target="_blank"
              >
                <i className="fab fa-facebook-square"></i>
              </Button>
              <UncontrolledTooltip delay={0} target="tooltip735272548">
                Like us on Facebook
              </UncontrolledTooltip>

              <Button
                className="btn-neutral btn-icon btn-round"
                color="facebook"
                href="https://instagram.com/chalorestro"
                id="tooltip735272548"
                size="lg"
                target="_blank"
              >
                <i className="fab fa-instagram"></i>
              </Button>
              <UncontrolledTooltip delay={0} target="tooltip735272548">
                Follow us on Instagram
              </UncontrolledTooltip>

            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Location;
